import PropTypes from 'prop-types';
import { Box, Typography } from '@mui/material';
import theme from 'theme';

const PolicyParagraph = ({ runs }) => (
  <Typography variant="body1" sx={{ marginTop: theme.spacing(2) }}>
    {runs.map((run, index) =>
      run.bold ? (
        <Box key={index} component="strong" fontWeight={600}>
          {run.text}
        </Box>
      ) : (
        run.text
      ),
    )}
  </Typography>
);

PolicyParagraph.propTypes = {
  runs: PropTypes.arrayOf(
    PropTypes.shape({
      text: PropTypes.string.isRequired,
      bold: PropTypes.bool,
    }),
  ).isRequired,
};

export default PolicyParagraph;
